module.exports = __webpack_public_path__ + "img/City1.png";